import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=04fc41e2&"
import script from "./SelectComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports